/**
 * Garde de sortie (bandeau invariant de formulaire, ADR-146 §5) : une fiche ouverte ne se quitte que par
 * « Sortir ». La route (lien du menu, retour du navigateur) demande la garde ; celle-ci reçoit de quoi
 * poursuivre et ouvre sa fenêtre de sortie. Une seule garde à la fois : la fiche affichée.
 */
export type LeaveGuard = (proceed: () => void) => void;

let current: LeaveGuard | null = null;

export function setLeaveGuard(guard: LeaveGuard | null): void {
  current = guard;
}

export function leaveGuard(): LeaveGuard | null {
  return current;
}

/** Retire la garde si c'est encore celle-ci (démontage d'une fiche remplacée entre-temps). */
export function clearLeaveGuard(guard: LeaveGuard): void {
  if (current === guard) current = null;
}
